export const CREATE_SESSION_REQUEST = 'CREATE_SESSION_REQUEST'
export const CREATE_SESSION_SUCCESS = 'CREATE_SESSION_SUCCESS'
export const CREATE_SESSION_ERROR = 'CREATE_SESSION_ERROR'

export const INITIALISATION_START = 'INITIALISATION_START'
export const INITIALISATION_COMPLETE = 'INITIALISATION_COMPLETE'
export const INITIALISATION_ERROR = 'INITIALISATION_ERROR'

export const GET_SESSION_DATA_REQUEST = 'GET_SESSION_DATA_REQUEST'
export const GET_SESSION_DATA_SUCCESS = 'GET_SESSION_DATA_SUCCESS'
export const GET_SESSION_DATA_ERROR = 'GET_SESSION_DATA_ERROR'
